import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { Marketplace } from "@front/m19-api-client";
import { Catalog } from "@front/m19-models";
import { AsinService } from "@front/m19-services";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AsinSelectionComponent } from "@m19-board/shared/asin-selection/asin-selection.component";
import { SpinnerComponent } from "@front/m19-ui";
import { catchError, of, map } from "rxjs";

@Component({
  templateUrl: "./brand-asins-modal.component.html",
  imports: [SpinnerComponent, AsinSelectionComponent, IButtonDirective, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandAsinsModalComponent {
  private asinService = inject(AsinService);
  private router = inject(Router);

  modalData = inject(MODAL_DATA) as BrandAsinsModalData;
  modalRef = inject(ModalRef);

  readonly asins = toSignal(
    this.asinService.getCatalog(this.modalData.accountId, this.modalData.marketplace).pipe(
      map((catalog: Catalog) =>
        catalog.products
          .filter((p) => p.brand?.toLowerCase() === this.modalData.brandName.toLowerCase())
          .map((p) => p.asin!),
      ),
      catchError(() => of([])),
    ),
  );

  openCatalog() {
    this.router.navigate(["/products/catalog"], {
      queryParams: { brand: this.modalData.brandName },
      queryParamsHandling: "merge",
    });
    this.modalRef.close();
  }

  close() {
    this.modalRef.close();
  }
}

export interface BrandAsinsModalData {
  brandName: string;
  accountId: string;
  marketplace: Marketplace;
}
